  // import { SaldosPendientesService } from './../../services/saldos-pendientes/saldos-pendientes.service';
  import { GeneralService } from './../../../services/admin/general.service';
  import { MyVouchersService } from './../../../services/my-vouchers/my-vouchers.service';
  import {
    Component,
    OnInit,
    ViewChild,
    TemplateRef,
    Input,
    Injectable,
    Inject
  } from '@angular/core';
  import {
    NgbModal,
    ModalDismissReasons
  } from '@ng-bootstrap/ng-bootstrap';
  import { CatalogsService } from './../../../services/catalogs/catalogs.service';
  import {
    ToasterService,
    ToasterConfig
  } from 'angular5-toaster';
  import { Observable } from 'rxjs/Observable';
  import { Subject } from 'rxjs/Subject';
  import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
  import { concat } from 'rxjs/observable/concat';
  import { of } from 'rxjs/observable/of';
  import 'rxjs/add/operator/map';
  import { StorageService } from '../../../services/storage.service';
  import { User } from '../../../models/user';
  import 'rxjs/add/operator/map';
  import { TranslateService } from '@ngx-translate/core';
  import {
    NgbDateStruct,
    NgbDatepickerI18n
  } from '@ng-bootstrap/ng-bootstrap';
  import {
    LOCAL_STORAGE,
    WebStorageService
  } from 'angular-webstorage-service';
  import { ENPOINT } from './../../../services/endpoint';

  const I18N_VALUES = {
    'es': {
      weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
      months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    },
    'en': {
      weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  };
  
  @Injectable()
  export class I18n {
    lang;
    language;
    constructor(
      @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    ) {
      // console.log(this.storage.get('LOCAL_STORAGE'));
      this.lang = this.storage.get('LOCAL_STORAGE');
  
      if (this.lang === 'es') {
        this.language = this.lang;
      } else {
        this.language = 'en';
      }
    }
  }
  
  @Injectable()
  export class CustomDatepickerI18n extends NgbDatepickerI18n {
  
    constructor(private _i18n: I18n) {
      super();
    }
  
    getWeekdayShortName(weekday: number): string {
      return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
    }
    getMonthShortName(month: number): string {
      return I18N_VALUES[this._i18n.language].months[month - 1];
    }
    getMonthFullName(month: number): string {
      return this.getMonthShortName(month);
    }
  
    getDayAriaLabel(date: NgbDateStruct): string {
      return `${date.day}-${date.month}-${date.year}`;
    }
  }
  
  @Component({
    selector: 'app-vouchersReport',
    templateUrl: './vouchers-report.component.html',
    styleUrls: ['./vouchers-report.component.scss'],
    providers: [MyVouchersService, I18n, {
      provide: NgbDatepickerI18n,
      useClass: CustomDatepickerI18n
    }]
  })

  export class VouchersReportComponent implements OnInit {
    private language = localStorage.getItem('LOCAL_STORAGE');
    @ViewChild('myTableSaldos') table: any;
    @ViewChild('detailsTemplate') detailsTemplateRef: TemplateRef<any>;
    @Input() messages: any = {
      emptyMessage: '',
      totalMessage: '',
      selectedMessage: ''
    };
    @Input() cerrarModal;
    public user: User;
    private basePath;
    verDetalle = false;
    rows = [];
    internalRows = [];
    rows2 = [
      {
        posicion: 1,
        material: 'Material 1',
        cantidadEntregada: 20,
        cantidadRecibida: 18,
        cantidadPendiente: 2
      },
      {
        posicion: 2,
        material: 'Material 2',
        cantidadEntregada: 46,
        cantidadRecibida: 40,
        cantidadPendiente: 6
      }
    ];

    response;
    busyBusqueda = false;

    closeResult: string;
    busy = false;
    rol = 0;
    pais = '';
    btnSeleccion = false;
    btnEnviar = false;
    modalProveedores;
    proveedores = [];
    ordenCompra;
    modelDate1;
    modelDate2;
    flagFecha1 = false;
    flagFecha2 = false;
    flagBtnExcel = false;
    loadingExcel = false;

    filtros = {
      proveedor: '',
      fechai: '',
      fechaf: '',
      ordenCompra: ''
    }

    fechaInicial;
    sinFechaI: boolean = false;
    fechaFinal;
    sinFechaF: boolean = false;
    proveedorField: boolean = false;
    fechaInicialMax;
    fechaFinalMax;
    factura = "";
    masterFactura = [];
    
    proveedorFilter;
    proveedores$: Observable<any>;
    proveedoresLoading = false;
    proveedorinput$ = new Subject<string>();

    toastMessage;

    fechaI = "";
    fechaF = "";
    noFactura = "";
    proveedor = "";
    btnShow: boolean = false;

    // private basePath = ENPOINT.url;
    constructor(
      private translate: TranslateService,
      private general: GeneralService,
      private storageService: StorageService,
      public catalogs: CatalogsService,
      private modalService: NgbModal,
      private toasterService: ToasterService,
      private myVouchersService: MyVouchersService
    ) {

      this.translate.get('texto.noHayInformacionLabel').subscribe(
        text => {
        this.messages.emptyMessage = text;
      });

      
      this.translate.get('texto.totalLabel').subscribe(
        text => {
        this.messages.totalMessage = text;
      });

      this.translate.get('texto.seleccionadoLabel').subscribe(
        text => {
        this.messages.selectedMessage = text;
      });

      this.translate.get('texto.toastCamposVacios').subscribe(
        text => {

          this.toastMessage = text;
      });
      
      this.basePath = ENPOINT.url;
      this.getProveedores();
  
    }
  
    ngOnInit() {
      if (this.language) {
        this.language = this.language.replace(/["']/g, "")
      } 

      this.noBack();
      this.user = this.storageService.getCurrentUser();
      this.rol = this.user.rol.id;
      this.pais = '';
      // this.getAllProveedores();
    }
  
    noBack() {
      history.pushState(null, null, location.href);
      window.onpopstate = function () {
        history.go(1);
      };
    }

    toggleExpandRow(row, expanded) {
      // console.log('Toggled Expand Row!', row, expanded);
      this.table.rowDetail.toggleExpandRow(row);
      
      if (!expanded) {
        this.busyBusqueda = true;
        this.masterFactura = [];
        
        this.myVouchersService.idRelacionados(row.id).subscribe(
          data => {
            
            if (data.masterFactura && data.masterFactura.length > 0) {
              this.masterFactura = data.masterFactura;

              for (let i of this.rows) {
                if (i.id === row.id) {
                  i.detailRow = this.masterFactura;
                }
              }

            } else {  
              this.masterFactura = [];
            }

            
            this.busyBusqueda = false;
          },
          err => {
          this.busyBusqueda = false;
          this.masterFactura = [];

          if (err.status === 401) {
              this.storageService.openLogout();
            }
          },
        );
      }
    }
  
    getAllProveedores() {
      this.catalogs.obtenerProveedores().subscribe(
          data => {
            this.proveedores = data.sapProveedor;
          },
          err => {
           if (err.status === 401) {
              this.storageService.openLogout();
            }
          },
      );
    }
  
    getProveedores() {
        this.proveedores$ = concat(of([]),
        this.proveedorinput$.pipe(
          debounceTime(200),
          distinctUntilChanged(),
    
          tap(() => this.proveedoresLoading = true),
          switchMap(term =>
            this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
        ))
        )
      );
    }
  
    selectProveedor() {
        // console.log(this.proveedorFilter)
       
    }

    openProveedores(content) {
      this.modalProveedores = this.modalService.open(content, {centered: true});
      this.modalProveedores.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
      });
    }
  
    private getDismissReasonFiltersOC(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

    onDateSelectIncial(e) {
      this.flagFecha1 = false;

      let anio = e.year;
      let mes, dia

      if (e.month < 10) {
        mes = '0'+e.month;
      } else {
        mes = e.month;
      }

      if (e.day < 10) {
        dia = '0'+e.day;
      } else {
        dia = e.day;
      }

      this.fechaInicial = anio+'-'+mes+'-'+dia; 
      this.sinFechaI = false;

      let fecha = new Date(this.fechaInicial);
      let dosSemanas = 1000 * 60 * 60 * 24 * 172;
      let fechaResta = fecha.getTime();
           
      let resta = fechaResta + dosSemanas;
      let date = new Date(resta);

      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      let dayF
      if (day < 10) {
          dayF = '0'+day;
      } else {
         dayF = day
      }

      let monthF
      if (month < 10) {
        monthF = '0'+month;
      } else {
        monthF = month
      }

    
      // this.fechaFinalMax = {
      //   day: Number(dayF),
      //   month: Number(monthF),
      //   year: year
      // };

      this.modelDate2 = null;

      if (this.fechaFinal == undefined || this.fechaFinal == "") {
        this.sinFechaF = true;

      } else {
        this.sinFechaF = true;
        
      }
    }
  
    onDateSelectFinal(e) {
      this.flagFecha2 = false;

      let anio = e.year;
      let mes, dia

      if (e.month < 10) {
        mes = '0'+e.month;
      } else {
        mes = e.month;
      }

      if (e.day < 10) {
        dia = '0'+e.day;
      } else {
        dia = e.day;
      }


      this.fechaFinal = anio+'-'+mes+'-'+dia;
      this.sinFechaF = false;


      let fecha = new Date(this.fechaFinal);
      let dosSemanas = 1000 * 60 * 60 * 24 * 180;
      let fechaResta = fecha.getTime();
           
      let resta = fechaResta - dosSemanas;
      let date = new Date(resta);

      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      let dayF
      if (day < 10) {
          dayF = '0'+day;
      } else {
         dayF = day
      }

      let monthF
      if (month < 10) {
        monthF = '0'+month;
      } else {
        monthF = month
      }
      
      this.fechaInicialMax = {
        day: Number(dayF),
        month: Number(monthF),
        year: year
      };

      if (this.fechaInicial == undefined || this.fechaInicial == "") {
        this.sinFechaI = true;

      } else {
        this.sinFechaI = false;
        
      }
    }

    onSelectProveedor() { 
      if (!this.proveedorFilter || this.proveedorFilter == "" || this.proveedorFilter == null) {
        this.proveedorField = true
      } else {
        this.proveedorField = false
      }
    }

    obtenerReporte() {
      this.flagBtnExcel = false;
      this.flagFecha1 = false;
      this.flagFecha2 = false;
      
      if (this.fechaInicial == undefined) {
        this.fechaInicial = "";
      } 

      if (this.fechaFinal == undefined) {
        this.fechaFinal = "";
      } 

      if (this.factura == undefined) {
        this.factura = "";
      } else {
        this.factura = this.factura;
      }

      if (this.rol == 3) { 
        this.proveedorFilter = this.user.id;
        this.proveedorField = false;
      } else {
        if (this.proveedorFilter !== undefined && this.proveedorFilter !== '' && this.proveedorFilter !== null) {
          this.proveedorField = false;
        } else {
          this.proveedorField = true;
        }
      }

      let busqueda = false;
      if (this.sinFechaI && !this.sinFechaF) {
        busqueda = false;
      } else if (!this.sinFechaI && this.sinFechaF) {
        busqueda = false;
      } else if (this.sinFechaI && this.sinFechaF && !this.proveedorField) {
        busqueda = true;
      }else if (!this.sinFechaI && !this.sinFechaF && !this.proveedorField) {
        busqueda = true;
      }

      if (!this.modelDate1) { this.flagFecha1 = true; }
      if (!this.modelDate2) {  this.flagFecha2 = true; }
      

      if (busqueda && !this.flagFecha1 && !this.flagFecha2) {
        this.busyBusqueda = true;
        this.myVouchersService.getReporte(this.fechaInicial, this.fechaFinal, this.factura, this.proveedorFilter).subscribe(
          data => {
            this.busyBusqueda = false;
  
            this.response = data.comprobante;

            this.fechaI = this.fechaInicial;
            this.fechaF = this.fechaFinal;
            this.noFactura = this.factura;
            this.proveedor = this.proveedorFilter;

            if (this.response && this.response.length) {
              this.rows = [...this.response];
              this.btnShow = true;
            } else {
              this.rows = [];
              this.btnShow = false;
            }
            
  
          },
          err => {
            this.busyBusqueda = false;
            this.rows = [];
            
            if (err.status === 401) {
              this.storageService.openLogout();
            } else {
              this.toasterService.pop('error', '', err.error.message);
            }
          },
        );

      } else {
        this.toasterService.pop('error', 'ERROR', this.toastMessage);
      }

    }
     
    getDocumento(i, url) {
      let ruta = btoa(this.basePath + url);

      this.myVouchersService.downloadPdf(url).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Documento.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );
    }
    
    borrarData() {
      this.modelDate1 = "";
      this.modelDate2 = "";
      this.fechaInicial = "";
      this.fechaFinal = "";
      this.factura = "";
      this.proveedorFilter = "";
    }
  
    descargarExcel() {
      let params = "?fechaInicial="+this.fechaI+"&fechaFinal="+this.fechaF;

      if (this.noFactura) {
        params += "&noDocumento="+this.noFactura;
      }
      if (this.proveedor) {
        params += "&proveedor="+this.proveedor;
      }

      this.loadingExcel = true;

      this.myVouchersService.downloadExcelReport(params).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'mis-comprobantes-pago.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el reporte:', error);
        },
        () => {
          this.loadingExcel = false;
        }
      );
    }

    descargarZip() {
      let parametros = "";
      parametros += "fechaInicial="+this.fechaI+"&fechaFinal="+this.fechaF;

      if (this.noFactura) {
        parametros += "&noDocumento="+this.noFactura;
      }
      if (this.proveedor) {
        parametros += "&proveedor="+this.proveedor;
      }

      let url = "comprobante/zip?" +parametros;


      const win = window.open(this.basePath + url, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }

    }
  }
  


// WEBPACK FOOTER //
// ./src/app/pages/my-vouchers/vouchers-report/vouchers-report.component.ts